var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 119,
    viewBox: "0 0 124 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.859 118.003H18.6725C5.33556 118.003 -3.33862 104.546 2.62562 93.1078L46.2189 9.50934C52.8304 -3.16978 71.7008 -3.16978 78.3124 9.50934L121.905 93.1077C127.87 104.545 119.196 118.003 105.859 118.003Z",
    fill: "url(#paint0_linear_10760_102878)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.859 118.003H18.6725C5.33556 118.003 -3.33862 104.546 2.62562 93.1078L46.2189 9.50934C52.8304 -3.16978 71.7008 -3.16978 78.3124 9.50934L121.905 93.1077C127.87 104.545 119.196 118.003 105.859 118.003Z",
    fill: "#FFC107"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M117.587 95.1775L73.9942 11.5792C71.7248 7.22712 67.3402 4.62891 62.2657 4.62891C57.1912 4.62891 52.8069 7.22712 50.5373 11.5792L6.94423 95.1775C4.89694 99.1035 5.11141 103.677 7.51816 107.41C9.92491 111.144 14.095 113.374 18.6725 113.374H105.859C110.437 113.374 114.607 111.144 117.014 107.41C119.42 103.677 119.635 99.1037 117.587 95.1775ZM112.907 104.977C111.386 107.336 108.752 108.744 105.859 108.744H18.6725C15.7804 108.744 13.1455 107.336 11.6252 104.977C10.1044 102.618 9.96896 99.7282 11.2626 97.2476L54.8556 13.6497C56.3108 10.8589 59.0114 9.25837 62.2655 9.25837C65.5196 9.25837 68.2205 10.8589 69.6754 13.6497L113.268 97.248C114.563 99.7282 114.427 102.618 112.907 104.977Z",
    fill: "#FFD761"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5708 94.214C55.5708 92.6054 56.2552 91.239 57.6237 90.1145C58.9924 88.9893 60.6558 88.4253 62.6111 88.4253C64.3331 88.4253 65.8216 88.9893 67.0767 90.1145C68.3321 91.239 68.9619 92.6054 68.9619 94.214C68.9619 95.7579 68.3325 97.1083 67.0767 98.2656C65.8216 99.4236 64.3329 100.002 62.6111 100.002C60.6556 100.002 58.9924 99.4234 57.6237 98.2656C56.2552 97.1083 55.5708 95.7583 55.5708 94.214ZM56.2293 37.5386C56.2293 35.9004 56.8105 34.6352 57.9736 33.7438C59.1361 32.8524 60.642 32.4062 62.491 32.4062C64.3399 32.4062 65.6983 32.8703 66.5642 33.7978C67.4302 34.725 67.8641 35.9718 67.8641 37.5386C67.8641 42.673 67.7712 45.058 67.5896 56.6772C67.4062 68.2968 67.3156 71.9581 67.3156 77.0905C67.3156 78.1615 66.7926 78.9998 65.7481 79.6048C64.7018 80.21 63.6163 80.513 62.4912 80.513C59.1951 80.513 57.5467 79.3732 57.5467 77.0907C57.5467 71.9583 57.3269 68.297 56.888 56.6774C56.4485 45.0578 56.2293 42.6728 56.2293 37.5386Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10760_102878",
    x1: 31.5873,
    y1: 50.4701,
    x2: 166.129,
    y2: 190.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59500"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsAlert);
export default __webpack_public_path__ + "static/media/icons-alert.acde488786276982b8d43955582be132.svg";
export { ForwardRef as ReactComponent };